import * as types from './company-tools-category.types';
import * as constants from './company-tools-category.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const companyToolsCategoryReducer = generateResourceReducer<types.ICompanyToolsCategory>({
  STORE: constants.STORE_COMPANY_TOOLS_CATEGORY,
  CLEAR: constants.CLEAR_COMPANY_TOOLS_CATEGORY,
});
